import { pathOr } from 'ramda';
import { SET_INTERNAL_TRANSITION } from '../../constants/history';
import type { RootState } from '../../store';

export interface HistoryState {
  isExternal: boolean;
}

export const initialState: HistoryState = {
  isExternal: true,
};

const reducer = (state = initialState, { type }) => {
  switch (type) {
    case SET_INTERNAL_TRANSITION: {
      return { ...state, isExternal: false };
    }
    default:
      return state;
  }
};

export default reducer;

export const isExternalTransitionSelector = (state: RootState) =>
  pathOr(initialState.isExternal, ['app', 'history', 'isExternal'], state);
